import { Spacer, VStack } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import ToolIcon from "./ToolIcon";

export function FixedSidebar() {
  const intl = useIntl();

  return (
    <VStack
      width="var(--toolbar-width)"
      bg="var(--header-sides-bg-color)"
      zIndex={1000}
      borderRight="solid 1px #dee5ea"
      gap="32px"
      paddingBottom="16px"
    >
      <ToolIcon
        scenarioEditMenu={"INFO"}
        tooltip={intl.formatMessage({
          id: "toolbox.info_tooltip",
          defaultMessage: "Simulation information",
        })}
      />
      <hr
        style={{
          width: "100%",
          height: "0px",
          color: "#dee5ea",
        }}
      />
      <ToolIcon
        scenarioEditMenu={"SELECTION"}
        tooltip={intl.formatMessage({
          id: "toolbox.selection_tooltip",
          defaultMessage: "Selection tool",
        })}
      />
      <ToolIcon
        scenarioEditMenu={"LINE_SELECTION"}
        tooltip={intl.formatMessage({
          id: "toolbox.line_selection_tooltip",
          defaultMessage: "Line-selection tool",
        })}
      />
      <hr
        style={{
          width: "100%",
          height: "0px",
          color: "#dee5ea",
        }}
      />
      <ToolIcon
        scenarioEditMenu={"DISCHARGE"}
        tooltip={intl.formatMessage({
          id: "toolbox.discharge_tooltip",
          defaultMessage: "Discharge tool",
        })}
      />
      <ToolIcon
        scenarioEditMenu={"PUMP"}
        tooltip={intl.formatMessage({
          id: "toolbox.pump_tooltip",
          defaultMessage: "Pump tool",
        })}
      />
      <ToolIcon
        scenarioEditMenu={"RAIN"}
        tooltip={intl.formatMessage({
          id: "toolbox.rain_tooltip",
          defaultMessage: "Rain tool",
        })}
      />
      <ToolIcon
        scenarioEditMenu={"WIND"}
        tooltip={intl.formatMessage({
          id: "toolbox.wind_tooltip",
          defaultMessage: "Wind tool",
        })}
      />
      <ToolIcon
        scenarioEditMenu={"RASTER_EDIT"}
        tooltip={intl.formatMessage({
          id: "toolbox.raster_edit_tooltip",
          defaultMessage: "Raster-edit tool",
        })}
      />
      <ToolIcon
        scenarioEditMenu={"LEVEE_TOOL"}
        tooltip={intl.formatMessage({
          id: "toolbox.levee_tool_tooltip",
          defaultMessage: "Flood barrier tool",
        })}
      />
      <Spacer />
      <ToolIcon
        scenarioEditMenu={"LAYERS"}
        tooltip={intl.formatMessage({
          id: "toolbox.layers_tooltip",
          defaultMessage: "Layers tool",
        })}
      />
    </VStack>
  );
}
